import { useMutation } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const deleteSnapshot = async (indexSetId) => DataTieringRepositories.deleteFailedSnapshot(indexSetId);
const useDeleteFailedSnapshotMutation = (indexSetId) => {
  const remove = useMutation({
    mutationFn: () => deleteSnapshot(indexSetId),
    onError: (errorThrown) => {
      UserNotification.error(`Snapshot deletion failed: ${errorThrown}`, "Could not delete snapshot");
    },
    onSuccess: () => {
      UserNotification.success("Snapshot has been successfully deleted.", "Success!");
    }
  });
  return { deleteFailedSnapshot: remove.mutateAsync };
};
export default useDeleteFailedSnapshotMutation;
